(function () {
  if (window.toccaySeriesPurchaseDelegated) return;
  window.toccaySeriesPurchaseDelegated = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function positionIndicator(root) {
    const tablist = root && root.querySelector('.toccay-g58-tabs');
    const tab = root && root.querySelector('[data-series-tab].is-active');
    if (!tablist || !tab) return;
    tablist.style.setProperty('--tab-indicator-x', `${tab.offsetLeft}px`);
    tablist.style.setProperty('--tab-indicator-width', `${tab.offsetWidth}px`);
  }

  function activateTab(root, tab, options) {
    if (!root || !tab || tab.getAttribute('aria-selected') === 'true') return;
    const settings = options || {};
    const name = tab.dataset.seriesTab;
    root.classList.toggle('is-confidence-view', name === 'confidence');
    root.querySelectorAll('[data-series-tab]').forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.classList.toggle('is-active', active);
      item.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-series-panel]').forEach((panel) => {
      const active = panel.dataset.seriesPanel === name;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
    positionIndicator(root);
    if (settings.focusTab) tab.focus({ preventScroll: true });
    const next = root.querySelector(`[data-series-panel="${name}"]`);
    if (!reduceMotion.matches && next && next.animate) next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-in-out' });
    if (settings.reveal) root.querySelector('.toccay-g58-tabs').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest' });
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-series-tab]');
    const serviceEntry = event.target.closest('[data-series-service-entry]');
    const regionSummary = event.target.closest('.toccay-g58-service-regions summary');
    const specsToggle = event.target.closest('[data-series-specs-toggle]');
    const trigger = tab || serviceEntry || regionSummary || specsToggle;
    const root = trigger && trigger.closest('[data-toccay-series-purchase]');
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    if (tab) activateTab(root, tab);
    if (serviceEntry) activateTab(root, root.querySelector('[data-series-tab="service"]'), { reveal: true });
    if (regionSummary) {
      const region = regionSummary.parentElement;
      const content = region.querySelector('.toccay-g58-region-content');
      if (reduceMotion.matches || !content || !content.animate) {
        region.open = !region.open;
      } else if (!region.dataset.animating) {
        region.dataset.animating = 'true';
        const opening = !region.open;
        if (opening) region.open = true;
        const startHeight = opening ? 0 : content.offsetHeight;
        const endHeight = opening ? content.scrollHeight : 0;
        content.animate(
          [{ height: `${startHeight}px`, opacity: opening ? 0 : 1 }, { height: `${endHeight}px`, opacity: opening ? 1 : 0 }],
          { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' }
        ).finished.then(() => {
          if (!opening) region.open = false;
          delete region.dataset.animating;
        }).catch(() => { delete region.dataset.animating; });
      }
    }

    if (specsToggle) {
      const expanded = root.classList.toggle('is-details-expanded');
      const collapsedText = specsToggle.dataset.collapsedText || specsToggle.textContent.trim();
      if (!specsToggle.dataset.collapsedText) specsToggle.dataset.collapsedText = collapsedText;
      specsToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      specsToggle.textContent = expanded ? (specsToggle.dataset.expandedText || collapsedText) : collapsedText;
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-series-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const root = tab.closest('[data-toccay-series-purchase]');
    const tabs = Array.from(root.querySelectorAll('[data-series-tab]'));
    const index = tabs.indexOf(tab);
    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    activateTab(root, tabs[nextIndex], { focusTab: true });
  });

  function initialize() {
    document.querySelectorAll('[data-toccay-series-purchase]').forEach((root) => {
      root.dataset.seriesPurchaseReady = 'true';
      root.querySelectorAll('[data-service-region]').forEach((region) => {
        if (!root.dataset.serviceRegionInitialized) region.open = false;
      });
      root.dataset.serviceRegionInitialized = 'true';
      positionIndicator(root);
    });
  }
  initialize();
  window.addEventListener('resize', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();

(function toccayMobilePdpCro20260831() {
  if (window.__toccayMobilePdpCro20260831) return;
  window.__toccayMobilePdpCro20260831 = true;

  var handles = [
    '/products/ghost-58-aero-wheelset',
    '/products/aero-60-ghost-wheelset-carbon-fiber-wheelset-disc-brake'
  ];
  var path = window.location.pathname.replace(/\/$/, '');
  if (handles.indexOf(path) === -1 || !window.matchMedia('(max-width: 767px)').matches) return;
  document.documentElement.classList.add('toccay-pdp-cro');

  function visible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    return rect.width > 1 && rect.height > 1 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function originalVariantArea() {
    return document.querySelector('.productView-moreItem-product-variant, variant-radios, variant-selects, .productView-options');
  }

  function incompleteSelection() {
    var area = originalVariantArea();
    if (!area) return false;
    var groups = Array.prototype.filter.call(area.querySelectorAll('.product-form__input, fieldset'), visible);
    return groups.some(function(group) {
      var radios = group.querySelectorAll('input[type="radio"]');
      if (radios.length) return !group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select[required], select');
      return !!(select && !select.value);
    });
  }

  function revealVariants() {
    var area = originalVariantArea();
    if (!area) return;
    var details = area.closest('details');
    if (details) details.open = true;
    area.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    var first = area.querySelector('input[type="radio"]:not(:checked), select');
    if (first) window.setTimeout(function(){ first.focus({ preventScroll: true }); }, 450);
  }

  function addTrustStrip() {
    if (document.querySelector('.toccay-mobile-trust-strip')) return;
    var atc = document.getElementById('product-add-to-cart');
    if (!atc) return;
    var host = atc.closest('.product-form__buttons, .productView-groupBottom, form') || atc.parentElement;
    var strip = document.createElement('div');
    strip.className = 'toccay-mobile-trust-strip';
    strip.setAttribute('aria-label', 'Purchase assurances');
    strip.innerHTML = '<p>Eligible Wheelsets Ship Free &middot; Duties Included Where Covered</p><p>3-Year Warranty &middot; One Free Crash Replacement</p><p>Secure Checkout</p>';
    var enabledPayments = document.querySelector('footer .list-payment, .footer .list-payment, .list-payment');
    if (enabledPayments) {
      var clone = enabledPayments.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function(node){ node.removeAttribute('id'); });
      strip.appendChild(clone);
    }
    host.insertAdjacentElement('afterend', strip);
  }

  function syncStickySummary() {
    var sticky = document.querySelector('.productView-stickyCart');
    if (!sticky) return;
    var actions = sticky.querySelector('.sticky-actions');
    if (!actions) return;
    var summary = actions.querySelector('.toccay-sticky-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'toccay-sticky-summary';
      summary.innerHTML = '<span class="toccay-sticky-price"></span><span class="toccay-sticky-variant"></span>';
      actions.insertBefore(summary, actions.firstChild);
    }
    var price = sticky.querySelector('.money-subtotal, .sticky-price .money, .sticky-price') || document.querySelector('.productView-price .price, .productView-price .money, [id^="product-price-"] .price');
    var variant = sticky.querySelector('variant-sticky-selects select, .sticky-options select');
    summary.querySelector('.toccay-sticky-price').textContent = price ? price.textContent.trim() : '';
    summary.querySelector('.toccay-sticky-variant').textContent = variant && variant.selectedOptions[0] ? variant.selectedOptions[0].textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function normalizeShippingCopy() {
    Array.prototype.forEach.call(document.querySelectorAll('.productView-info-item, .toccay-g58-assurance-line li, [data-shipping-copy]'), function(node) {
      var text = (node.textContent || '').trim();
      if (/Free Worldwide Shipping/i.test(text) || /^Free Shipping\s*\/\s*Duties Included$/i.test(text)) {
        node.textContent = 'Eligible Wheelsets Ship Free \u00b7 Duties Included Where Covered';
      }
    });
  }

  function stickyState(active) {
    document.body.classList.toggle('toccay-sticky-active', active);
    if (active) syncStickySummary();
    var sticky = document.querySelector('.productView-stickyCart');
    if (sticky && !active) sticky.classList.remove('show-sticky', 'animate');
  }

  function initialize() {
    addTrustStrip();
    syncStickySummary();
    normalizeShippingCopy();
    var original = document.getElementById('product-add-to-cart');
    if (original && !original.dataset.toccayCroObserved) {
      original.dataset.toccayCroObserved = 'true';
      var frame = 0;
      var updateSticky = function() {
        frame = 0;
        var rect = original.getBoundingClientRect();
        stickyState(rect.bottom < 0);
      };
      var scheduleSticky = function() {
        if (!frame) frame = window.requestAnimationFrame(updateSticky);
      };
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky, { passive: true });
      updateSticky();
    }
  }

  document.addEventListener('click', function(event) {
    var sticky = event.target.closest('.productView-stickyCart');
    if (!sticky) return;
    var submit = event.target.closest('button[type="submit"], [name="add"], #show-sticky-product');
    if (!submit || !incompleteSelection()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    revealVariants();
  }, true);

  document.addEventListener('change', function(){ window.setTimeout(syncStickySummary, 350); }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.setTimeout(initialize, 1200);
})();
